/**
 * Orden de campos para formularios de vehículos:
 * Fila 1: Placa, Año
 * Fila 2: Marca, Modelo
 * Fila 3: Fecha marbete, Color
 * Fila 4: VIN (ancho completo)
 */
export const VEHICLE_FIELD_ORDER = [
  'placa',
  'año',
  'marca',
  'modelo',
  'date_marbete',
  'color',
  'vin',
] as const;

export const getVehicleFieldSortKey = (
  name: string | undefined,
  nameIntlEng: string | undefined
): number => {
  const n = name?.toLowerCase() ?? '';
  const ni = nameIntlEng?.toLowerCase() ?? '';
  const idx = VEHICLE_FIELD_ORDER.findIndex((id) => n === id || ni === id);
  return idx === -1 ? 999 : idx;
};
